import React, { useState } from "react";
import {
  Grid,
  Box,
  TextField,
  FormLabel,
  Button,
  InputAdornment,
  IconButton,
} from "../../components/ui";
import { toast } from "react-toastify";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { Visibility, VisibilityOff } from "../../components/icons";
import { path } from "../../navigation/path";

const UpdatePassword = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  const handleChange = (key: any, value: any) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSave = async () => {
    if (!formData?.password) {
      toast.error("Password is required");
      return;
    }
    try {
      const resp: any = await axiosInstance.put(`/api/auth/${id}`, formData);
      if (resp.status === 200) {
        toast.success("Password Changed successfully");

        navigate(path.LOGIN);
      }
    } catch (Error: any) {
      console.log(Error);
      toast.error(Error?.response?.data?.body);
    }
  };
  return (
    <div>
      <Box
        width={"100%"}
        height={"98vh"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box width={"30%"}>
          <Grid container spacing={2}>
            <Grid size={12} display={"flex"} justifyContent={"center"}>
              <h2 color="#1F2937">Password</h2>
            </Grid>

            <Grid size={12}>
              <Box display={"grid"}>
                <FormLabel>New Password</FormLabel>
                <TextField
                  size="small"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  onChange={(e: any) =>
                    handleChange("password", e?.target?.value)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />{" "}
              </Box>
            </Grid>
            <Grid size={12} display={"flex"} justifyContent={"end"}>
              <Button
                variant="contained"
                size="small"
                // color="success"
                sx={{ mx: 1, bgcolor: "#1F2937" }}
                onClick={handleSave}
              >
                Save
              </Button>
            </Grid>
            {/* <Grid size={12} display={"flex"} justifyContent={"center"}>
              <Box>
                <a
                  // href="#"
                  style={{ textDecoration: "none", color: "#1F2937" }}
                  onClick={() => navigate(path.FORGOT_PASSWORD)}
                >
                  Forgot Password?
                </a>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default UpdatePassword;
